/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { DatePicker, Space } from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import { Dayjs } from 'dayjs'
import React from 'react'
import { colors } from '../../theme'

const { RangePicker } = DatePicker

interface Props {
  handlePeriodoSelecionado: (dataInicio: string, dataFim: string) => void
  size: string
  background?: boolean
  defaultValue?: [Dayjs, Dayjs]
}

const PeriodPicker: React.FC<Props> = ({
  handlePeriodoSelecionado,
  size,
  background,
  defaultValue,
}) => {
  const onChange: RangePickerProps['onChange'] = (dates, dateStrings) => {
    handlePeriodoSelecionado(dateStrings[0], dateStrings[1])
  }
  return (
    <Space direction="vertical">
      <RangePicker
        style={{
          backgroundColor: background ? colors.surface : colors.grey100,
          width: size,
        }}
        onChange={onChange}
        defaultValue={defaultValue}
        format="DD/MM/YYYY"
        placeholder={['Data início', 'Data fim']}
        allowEmpty={[true, true]}
      />
    </Space>
  )
}

export default PeriodPicker
